import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

const K: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    return (
        <section
            className={`${css.section} stream-ultra-x-K GtmModuleData-section`}
            id="stream-ultra-x-K"
            data-section-id={'stream-ultra-x-K'}
            data-section-title={t('K_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1754396381305/11-pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1754039118733/11_M.jpg"
                isOpenLazy={true}
            />
            <div className="info">
                <p className="title">{t('K_title')}</p>
                <p className="desc">{t('K_desc')}</p>
            </div>
            <div className="position-block" id="stream-ultra-x-K-position"></div>
        </section>
    );
};

export default K;
